export const isValidValue = (value: string): boolean => /^[\d:]+$/.test(value);
